module.exports = __webpack_public_path__ + "img/s23.cb63fe0d.png";